<script setup>
import Empty from "@/assets/empty.png";
</script>

<template>
  <div class="empty">
    <van-image :src="Empty" class="empty-img" />
    <div class="empty-text">暂无资源</div>
  </div>
</template>

<style lang="scss" scoped>
.empty {
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.empty-img {
  width: 88px;
  height: 70px;
  margin-bottom: 8px;
}
.empty-text {
  font-size: 12px;
  line-height: 20px;
  color: #0000004d;
}
</style>
